import Select, { SelectProps } from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import ChevronDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ChevronUpIcon from "@mui/icons-material/KeyboardArrowUp";

const ModelFormSelect = styled(Select)<SelectProps>(({ theme }) => ({
  "& .MuiInputBase-input": {
    fontSize: 14,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}));

ModelFormSelect.defaultProps = {
  IconComponent: (props) =>
    props.className?.includes("MuiSelect-iconOpen") ? (
      <ChevronUpIcon sx={{ color: "#4F4F52" }} />
    ) : (
      <ChevronDownIcon sx={{ color: "#4F4F52" }} />
    ),
};

export default ModelFormSelect;
